//
//
//
//
//
//
//
//
//
//
//

export default {
  created() {
    this.rightButtons = [
      {
        content: 'Mark as Unread',
        style: { background: 'lightgray', color: '#fff' }
      },
      {
        content: 'Delete',
        style: { background: 'red', color: '#fff' },
        handler: () => this.$messagebox('delete')
      }
    ];
  },

  methods: {
    leftButtonHandler(evt) {
      console.log(123);
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/cell-swipe.vue